/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of a team member
 * @export
 */
export const TeamMemberStatus = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    REMOVED: 'REMOVED'
} as const;
export type TeamMemberStatus = typeof TeamMemberStatus[keyof typeof TeamMemberStatus];


export function instanceOfTeamMemberStatus(value: any): boolean {
    for (const key in TeamMemberStatus) {
        if (Object.prototype.hasOwnProperty.call(TeamMemberStatus, key)) {
            if (TeamMemberStatus[key as keyof typeof TeamMemberStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TeamMemberStatusFromJSON(json: any): TeamMemberStatus {
    return TeamMemberStatusFromJSONTyped(json, false);
}

export function TeamMemberStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamMemberStatus {
    return json as TeamMemberStatus;
}

export function TeamMemberStatusToJSON(value?: TeamMemberStatus | null): any {
    return value as any;
}

export function TeamMemberStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): TeamMemberStatus {
    return value as TeamMemberStatus;
}

